<template>
  <div class="c-pagination">
    <div class="c-pagination-wrap" v-if="pages > 1">
      <div class="c-pagination-item" v-if="loading !== null">
        {{ loading }}
      </div>
      <div class="c-pagination-item">
        {{ page }}/{{ pages }} stron
      </div>
      <div class="c-pagination-item active" v-on:click="scrollTop()">
        Powrót na górę
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Pagination',
  props: [
    'page',
    'pages'
  ],
  data: function(){
    return {
      loading:null
    }
  },
  methods:{
    scrollTop: function(){
      window.scrollTo(0, 0);
    }
  },
  mounted: function(){
    var that = this;
var t = 1;
    window.onscroll = function() {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight && that.page != that.pages) {
        var p = that.page+1;
        that.$emit('page', p);
        that.loading = 'Ładowanie ofert...';
      }else{
        that.loading = null;
      }
    };
  }
}
</script>
<style lang="scss">
  .c-pagination{
    margin: 0 auto;
    max-width: 1177.6px;
    width: 92%;
    padding: 1rem 0 0 0;
    margin-top: 2rem;
    border-top: 1px solid #b3b3b3;
    &-wrap{
      display: flex;
      justify-content: flex-end;
    }
    &-item{
      &.active{
        background-color: #c03;
        border: 1px solid #c03;
        color: #fff;
      }
      cursor: pointer;
      padding: .5rem;
      border: 1px solid #b3b3b3;
      margin-right: .5rem;
    }
  }
</style>
